import { render, staticRenderFns } from "./_userBoxDistributor.vue?vue&type=template&id=9bb9e960&"
import script from "./_userBoxDistributor.vue?vue&type=script&lang=js&"
export * from "./_userBoxDistributor.vue?vue&type=script&lang=js&"
import style0 from "./_userBoxDistributor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports